/* eslint-disable */
// 正则表示
// 手机号
const phone = /^1\d{10}$/
// 邮箱
const email = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
// 数字
const number = /^[0-9, ,_]*$/
// 数字和小数点
const numberOrPoint = /^\d+(\.\d+)?$/
// 校验浮点数和负数数字
// const numbe = /^(-?\d+)(\.\d+)?$/÷
// 正数、负数、和小数：
const numberOrPointOrSymbol = /^(\-|\+)?\d+(\.\d+)?$/
// 检验小数位
const floatLength = /^\d+(\.(\d+))?$/
// 正整数：
const positiveInteger = /^[+]{0,1}(\d+)$/
// 正数的正则表达式(不包括0，小数保留两位)：
const positiveTwoFloatExcludeZero = /^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*))$/
export default {
    phone,
    email,
    number,
    numberOrPoint,
    numberOrPointOrSymbol,
    floatLength,
    positiveInteger,
    positiveTwoFloatExcludeZero
}
